module.exports = __webpack_public_path__ + "static/media/iphone 11 banner2.94f9b65c.jpg";